/** Return the highest risk contributed by an open laboratory incident. */
export function incidentRisk(incidents: Array<{status:string;severity:string}>) {
  const open = incidents.filter(i => i.status !== 'closed');
  return open.some(i => i.severity === 'critical') ? {likelihood:5,consequence:5} : open.length ? {likelihood:4,consequence:3} : null;
}
